export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const TOGGLE_PRELOADER = 'TOGGLE_PRELOADER';
export const SET_AUTHORIZED = 'SET_AUTHORIZED';
export const SET_MEETINGS = 'SET_MEETINGS';
export const SET_LNGS_LOADED = 'SET_LNGS_LOADED';
